"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddGroup = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("./styles.js");

var _search = _interopRequireDefault(require("../../../assets/images/Icons/search.svg"));

var _addv = _interopRequireDefault(require("../../../assets/images/Icons/addv2.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var AddGroup = function AddGroup(_ref) {
  var id = _ref.id,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      _ref$defaultSearch = _ref.defaultSearch,
      defaultSearch = _ref$defaultSearch === void 0 ? "" : _ref$defaultSearch,
      _ref$defaultOption = _ref.defaultOption,
      defaultOption = _ref$defaultOption === void 0 ? "" : _ref$defaultOption,
      onChange = _ref.onChange,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder;

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      itemsSelected = _useState2[0],
      setItemsSelected = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultSearch),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      search = _useState4[0],
      setSearch = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      containerVisible = _useState6[0],
      setContainerVisible = _useState6[1];

  var itemsFiltered = function () {
    if (!search) return items;
    return items.filter(function (item) {
      return item.label.toLowerCase().includes(search.toLowerCase());
    });
  }();

  (0, _react.useEffect)(function () {
    onChange && onChange(itemsSelected);
  }, [itemsSelected]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    id: id,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      className: "custom-select",
      onClick: function onClick() {
        return setContainerVisible(!containerVisible);
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _addv.default,
        className: "add-icon",
        alt: "add icon"
      })
    }), containerVisible && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "container-def",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "search-bar",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _search.default,
          className: "search-icon",
          alt: "search icon"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          type: "text",
          className: "search",
          onChange: function onChange(e) {
            setSearch(e.target.value);
          },
          value: search,
          placeholder: placeholder
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "default-option",
        children: defaultOption
      }), itemsFiltered.map(function (item, i) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "container-options",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "options",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
              id: "custom-check",
              className: "custom-check",
              type: "checkbox",
              checked: itemsSelected.includes(item.value),
              onChange: function onChange(e) {
                setItemsSelected(function (prev) {
                  var existItem = prev.find(function (e) {
                    return e === item.value;
                  });

                  if (existItem) {
                    return (0, _toConsumableArray2.default)(prev).filter(function (e) {
                      return e !== item.value;
                    });
                  }

                  return [].concat((0, _toConsumableArray2.default)(prev), [item.value]);
                });
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
              htmlFor: "",
              className: "texto",
              children: item.label
            })]
          }, i)
        });
      })]
    })]
  });
};

exports.AddGroup = AddGroup;